(function ($) {

  Drupal.behaviors.myplate_tooltips = {
    attach: function (context, settings) {
      applyTooltips(context);
    }
  };

  function applyTooltips(context) {

    const $triggers = $(once('tooltip', '[data-mp-tooltip-trigger]', context));
    if (!$triggers.length) {
      return;
    }
    $triggers
      .each(function() {
        const $trigger = $(this),
          name = $trigger.data('mp-tooltip-trigger'),
          $tooltip = $('[data-mp-tooltip="' + name + '"]'),
          $close = $tooltip.find('[data-mp-tooltip-close]')
        ;

        const instance = tippy($trigger[0], {
          trigger: 'click',
          onTrigger(instance, event) {
            event.preventDefault();
            event.stopPropagation();
          },
          onUntrigger(instance, event) {
            event.preventDefault();
            event.stopPropagation();
          },
          content: $tooltip[0],
          interactive: true
        });

        $tooltip.on('click', function (e) {
          e.stopPropagation();
        });

        $close.on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          instance.hide();
        });
      })
    ;
  }

})(jQuery);
